module.exports = __webpack_public_path__ + "img/wechat.92063e80.png";